<template>
    <div>
        <el-form ref="formData" :rules="rules" class="mrt20 " size="mini" label-width="120px" :model="formData" :inline="true">
                <el-form-item label="ID"  prop="i_id">{{formData.i_id}}</el-form-item>
                <el-form-item :label="$t('yewuPM_product_name')" prop="vc_pzname" required>
                    <div @click="chooseName" style="cursor: pointer" :class="baseerp+'color'">{{formData.vc_pzname?formData.vc_pzname:$t('yewuPM_select_product_name')}}</div>
<!--                    <el-input v-model="formData.vc_name" @focus.stop="chooseName" placeholder="选择产品名称"  size="mini"></el-input>-->
                </el-form-item >
                <el-form-item :label="$t('yewuPM_specification_name')" prop="vc_name" required>
                    <el-input v-model="formData.vc_name"  :placeholder="$t('yewuPM_specification_name')"  @input="vc_nameChange" size="mini"></el-input>
                </el-form-item >
            <el-form-item :label="$t('yewuPM_contract_display_name')"  prop="vc_name_nick" required>
                <el-input v-model="formData.vc_name_nick" clearable size="mini"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yewuPM_english_name')"  prop="vc_ename"　 required>
                <el-input v-model="formData.vc_ename" clearable size="mini"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yewuPM_export_or_not')" class="w50"  prop="i_isexport" required>
                <el-radio-group v-model="formData.i_isexport" >
                    <el-radio :label='0'>{{$t('form_deny')}}</el-radio>
                    <el-radio :label='1'>{{$t('form_correct')}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item  prop="vc_exname" :label="$t('yewuPM_foreign_trade_product_name')" :required="formData.i_isexport==1">
                <el-input  class="changeinput" size="mini" v-model="formData.vc_exname"  ></el-input>
            </el-form-item>


                <el-form-item :label="$t('yewuPM_origin')"  prop="vc_cd">
                    <el-input v-model="formData.vc_cd" clearable size="mini" :disabled="ifdisabled"></el-input>
                </el-form-item>
                <el-form-item :label="$t('yewuPM_manufacturer')"  prop="vc_gykh">
                    <el-input v-model="formData.vc_gykh" clearable size="mini" :disabled="ifdisabled"></el-input>
                </el-form-item>
                <el-form-item :label="$t('yewuPM_packaging_specification')" class="w50"  prop="vc_bzstyle">
                    <el-input  v-model="formData.vc_bzstyle" clearable size="mini" :disabled="ifdisabled"></el-input>
                </el-form-item>
                <el-form-item :label="$t('yewuPM_packaging_unit')" prop="vc_bzunit" class="w50" >
                    <el-select v-model="formData.vc_bzunit" style="width: 100%" filterable size="mini" :disabled="ifdisabled">
                        <el-option
                                v-for="item in bzdwList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item :label="$t('yewuPM_conversion_ratio')" prop="f_bl" class="w50" required>
                    <el-input-number class="w100" :controls="false" v-model="formData.f_bl" clearable size="mini" :disabled="ifdisabled" :precision="6" ></el-input-number>
                </el-form-item>
                <el-form-item :label="$t('yewuPM_single_net_weight')" prop="f_weight" class="w50" required>
                    <el-input-number class="w100" :controls="false" v-model.number="formData.f_weight" clearable size="mini" :disabled="ifdisabled" :precision="4" ></el-input-number>
                </el-form-item>
                <el-form-item :label="$t('yewuPM_weight_unit_per_piece')" prop="vc_djunit" class="w50" required>
                    <el-select v-model="formData.vc_djunit" style="width: 100%" filterable clearable size="mini" :disabled="ifdisabled">
                        <el-option
                                v-for="item in jzdwList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>

            <el-form-item :label="$t('yewuPM_belonging_sector')" prop="i_sector_id" class="w50" required>
                <el-select v-model="formData.i_sector_id"  size="mini" @change="changeSector" :remote="true"
                           :remote-method="bksearch"   style="width: 100%" >
                    <el-option
                            v-for="item in bkList"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
                <el-form-item :label="$t('yewuPM_goods_nature')" prop="vc_type" class="w50" required>
                    <el-select  v-model="formData.vc_type" style="width: 100%"   size="mini" :disabled="ifdisabled">
                        <el-option
                                v-for="item in things"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>
            <el-form-item :label="$t('yewuPM_product_attribute')" prop="i_flag" class="w50" required>
                <el-select  v-model="formData.i_flag" style="width: 100%" size="mini"  disabled>
                    <el-option
                            v-for="item in flagList"
                            :key="item.i_flag"
                            :label="item.vc_flag"
                            :value="item.i_flag">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('yewuPM_measurement_unit')" prop="vc_unit" class="w50" required>
                <el-select v-model="formData.vc_unit" style="width: 100%" filterable  size="mini" :disabled="ifdisabled||data.i_id!=0">
                    <el-option
                            v-for="item in dictList"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.vc_name">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('yewuPM_pricing_unit')" prop="vc_priceunit" class="w50">
                <el-select v-model="formData.vc_priceunit" style="width: 100%" filterable clearable size="mini" disabled>
                    <el-option
                            v-for="item in dictList"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.vc_name">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('yewuPM_type')" class="w50"  prop="i_isprocess" required>
                <el-select   class="marr4" v-model="formData.i_isprocess" size="mini" disabled  :placeholder="$t('yewuPM_please_select_type')">
                    <el-option v-for="item in jgList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('yewuPM_associated_product')" prop="vc_relate_pz" v-if="formData.i_isprocess!=2">
                <div @click="chooseNameglcp" style="cursor: pointer" :class="baseerp+'color'">{{formData.vc_relate_pz?formData.vc_relate_pz:$t('yewuPM_select_associated_product')}}</div>
            </el-form-item >
                <el-form-item :label="$t('yewuPM_use_packaging_or_not')" class="w50"  prop="isusepack" required>
                    <el-radio-group :disabled="ifdisabled" v-model="formData.isusepack" >
                        <el-radio :label='0'>{{$t('form_deny')}}</el-radio>
                        <el-radio :label='1'>{{$t('form_correct')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('yewuPM_enabled_or_not')" class="w50"  prop="isuse" required>
                    <el-radio-group :disabled="ifdisabled" v-model="formData.isuse" >
                        <el-radio :label='0'>{{$t('form_deny')}}</el-radio>
                        <el-radio :label='1'>{{$t('form_correct')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('yewuPM_sync_to_ecommerce_or_not')" class="w50"  prop="isec" required>
                    <el-radio-group :disabled="ifdisabled" v-model="formData.isec" >
                        <el-radio :label='0'>{{$t('form_deny')}}</el-radio>
                        <el-radio :label='1'>{{$t('form_correct')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('yewuPM_mandatory_inspection_on_unloading_or_not')" class="w50"  prop="i_ismustcheck" required>
                    <el-radio-group :disabled="ifdisabled" v-model="formData.i_ismustcheck" >
                        <el-radio :label='0'>{{$t('form_deny')}}</el-radio>
                        <el-radio :label='1'>{{$t('form_correct')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('yewuPM_assay_required_or_not')" class="w50"  prop="i_assayres" required>
                    <el-radio-group :disabled="ifdisabled" v-model="formData.i_assayres" >
                        <el-radio :label='0'>{{$t('form_deny')}}</el-radio>
                        <el-radio :label='1'>{{$t('form_correct')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
<!--            <el-form-item label="是否加工:" class="w50"  prop="i_isprocess" required>-->
<!--                <el-radio-group disabled v-model="formData.i_isprocess" >-->
<!--                    <el-radio :label='0'>否</el-radio>-->
<!--                    <el-radio :label='1'>是</el-radio>-->
<!--                </el-radio-group>-->
<!--            </el-form-item>-->

            <el-form-item :label="$t('yewuPM_piece_counting_or_not')" class="w50"  prop="isjian" required>
                <el-radio-group disabled v-model="formData.isjian" >
                    <el-radio :label='0'>{{$t('form_deny')}}</el-radio>
                    <el-radio :label='1'>{{$t('form_correct')}}</el-radio>
                </el-radio-group>
            </el-form-item>
                <el-form-item :label="$t('yewuPM_bulk_non_bulk')" class="w50"  prop="i_isbulk" required>
                    <el-radio-group disabled v-model="formData.i_isbulk" >
                        <el-radio :label='1'>{{$t('yewuPM_bulk')}}</el-radio>
                        <el-radio :label='0'>{{$t('yewuPM_non_bulk')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
<!--                <el-form-item label="ERP库存核算:"   prop="i_pzid_kcjs_sel" required>-->
<!--                    <el-radio-group :disabled="ifdisabled" v-model="formData.i_pzid_kcjs_sel" >-->
<!--                        <el-radio :label='0'>大类ID</el-radio>-->
<!--                        <el-radio :label='1'>规格ID</el-radio>-->
<!--                    </el-radio-group>-->
<!--                </el-form-item>-->
            <el-form-item  prop="i_syncyy_type" :label="$t('yewuPM_ufida_sync_mode')" disabled required>
<!--                <el-radio-group disabled v-model="formData.i_syncyy_type" >-->
<!--                    <el-radio :label='1'>按产品</el-radio>-->
<!--                    <el-radio :label='2'>按规格</el-radio>-->
<!--                </el-radio-group>-->
                <span v-if="formData.i_syncyy_type==1">{{$t('yewuPM_by_product')}}</span>
                <span v-if="formData.i_syncyy_type==2">{{$t('yewuPM_by_specification')}}</span>
            </el-form-item>
            <el-form-item :label="$t('yewuPM_ufida_code')" class="w50"  prop="vc_code_yongyou" v-if="formData.i_syncyy_type==2">
                <span style="margin-right: 3px">{{formData.vc_code_yongyou}}</span>
            </el-form-item>
            <el-form-item :label="$t('yewuPM_nanbei_code')" class="w50"  prop="vc_code_nanbei">
                <span style="margin-right: 3px">{{formData.vc_code_nanbei}}</span>
            </el-form-item>
            <el-form-item :label="$t('yewuPM_financial_cost_accounting')"   prop="i_type_sel" required >
<!--                        {{formData.i_type_sel?'规格ID':'大类ID'}}-->
                        <el-radio-group :disabled="formData.i_syncyy_type==1" v-model="formData.i_type_sel" >
                            <el-radio :label='0'>{{$t('yewuPM_by_product')}}</el-radio>
                            <el-radio :label='1'>按批次</el-radio>
                        </el-radio-group>
                    </el-form-item>
                <el-form-item  prop="i_ispno" :label="$t('yewuPM_erp_statistical_granularity')" required>
                    <el-radio-group disabled v-model="formData.i_ispno" >
                        <el-radio :label='2'>{{$t('yewuPM_specification')}}</el-radio>
                        <el-radio :label='3'>{{$t('yewuPM_batch')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-table border ref="sgtable1" size="mini" v-if="formData.i_syncyy_type==2&&distributedList.length>0" :data="distributedList" :height="tableHeight-100"
                          :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true">
                    <el-table-column type="index" :label="$t('yewuPM_serial_number')" width="50"></el-table-column>
                    <el-table-column  prop="vc_gsname"  :label="$t('yewuPM_issuing_company')"  show-overflow-tooltip></el-table-column>
                    <el-table-column  prop="vc_pz_attr"  :label="$t('yewuPM_attribute')"  show-overflow-tooltip></el-table-column>
                </el-table>
            <div class="flex">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_input_person')" >
                    <span>{{formData.vc_lruname}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="dt_createtime" :label="$t('form_entry_date')" >
                    <span>{{formData.dt_createtime}}</span>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button type="primary" @click="saveadd('formData')" size="small" v-if="isuse"  :class="baseerp+'btn'" :disabled="disabled">{{$t('button_save')}}</el-button>
            <el-button @click="resetFormson()"  size="small" >{{$t('button_cancel')}}</el-button>
        </div>
        <el-dialog :title="$t('yewuPM_select_specification')" width="80%" :class="baseerp+'div'" top="30px" v-if="mcVisible" :visible.sync="mcVisible" append-to-body :modal-append-to-body="true" :close-on-click-modal="false">
            <ming-cheng :data="mcData" @close="mcClose"></ming-cheng>
        </el-dialog>
        <el-dialog :title="$t('yewuPM_select_associated_product')" width="80%" :class="baseerp+'div'" top="30px" v-if="glcpVisible" :visible.sync="glcpVisible" append-to-body :modal-append-to-body="true" :close-on-click-modal="false">
            <guan-lian-pz :data="glcpData" @close="glcpClose"></guan-lian-pz>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from  "./api";
    import {mapActions} from "vuex";
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";
    import MingCheng from "./MingCheng";
    import GuanLianPz from "@/views/zhushujuPM/GuanLianPz";

    export default {
        name:"ChanpinGuige",
        components:{MingCheng,GuanLianPz},
        props: {
            data: {
                type: Object,
                required: true,
            }
        },
        data(){
            var validateExname = (rule, value, callback) => {
                if (value === ''&&this.formData.i_isexport==1) {
                    callback(new Error(this.$t('yewuPM_please_enter_foreign_trade_product_name')));
                } else {
                    callback();
                }
            };
            return{
                tableHeight:0,
                baseerp:'',
                before:{},
                formData:{
                    i_id: 0,
                    vc_name: "",
                    vc_pzname: "",
                    vc_name_nick: "",
                    vc_ename: "",
                    vc_cd: "",
                    vc_gykh: "",
                    vc_bzstyle: "",
                    vc_bzunit: "",
                    f_bl: 1.00,
                    vc_unit: this.$t('yewuPM_ton'),
                    f_weight: 0,
                    i_isbulk:0,
                    vc_type:this.$t('yewuPM_general_cargo'),
                    vc_djunit:"KG",
                    isec: 0,
                    isjian: 0,
                    i_flag: "",
                    i_type_sel:0,
                    isusepack:0,
                    i_ispno:2,
                    i_pzid_kcjs_sel:1,
                    isuse:1,i_ismustcheck:0,i_assayres:0,
                    i_isprocess:0,vc_exname:'',i_syncyy_type:'',
                    vc_priceunit: this.$t('yewuPM_ton'),i_isexport:0,i_sector_id:'',
                    vc_code_yongyou:'',
                    vc_code_nanbei:'',
                    i_unitgroup_id:0,
                },
                distributedList:[],
                dictList:[],
                jzdwList:[],
                flagList:[],
                bzdwList:[],
                things:[{i_id:this.$t('yewuPM_dangerous_goods'),vc_name:this.$t('yewuPM_dangerous_goods')},{i_id:this.$t('yewuPM_general_cargo'),vc_name:this.$t('yewuPM_general_cargo')}],
                disabled:false,
                ifdisabled:false,
                mcVisible:false,
                mcData:{},
                bk_seaech:'',
                bkList:[],
                jgList:[{i_id:0,vc_name:this.$t('yewuPM_default')},{i_id:1,vc_name:this.$t('yewuPM_entrusted_processing')},{i_id:2,vc_name:this.$t('yewuPM_research_development')},{i_id:3,vc_name:this.$t('yewuPM_outsourced_processing')}],
                glcpData:{},
                glcpVisible:false,
                rules:{
                    vc_pzname:[{required: true,message:this.$t('yewuPM_select_product_name')}],
                    vc_name:[{required: true,message:this.$t('yewuPM_please_enter_specification_name')}],
                    vc_name_nick:[{required: true,message:this.$t('yewuPM_please_enter_contract_display_name')}],
                    vc_ename:[{required: true,message:this.$t('yewuPM_please_enter_english_name')}],
                    f_weight:[{required: true,message:this.$t('yewuPM_please_enter_single_net_weight')}],
                    vc_unit:[{required: true,message:this.$t('yewuPM_please_select_measurement_unit')}],
                    vc_type:[{required: true,message:this.$t('yewuPM_please_select_goods_nature')}],
                    f_bl:[{required: true,message:this.$t('yewuPM_please_enter_conversion_ratio')}],
                    i_sector_id:[{required: true,message:this.$t('yewuPM_please_enter_belonging_sector')}],
                    i_flag:[{required: true,message:this.$t('yewuPM_please_select_product_attribute')}],
                    vc_exname:[{validator:validateExname,trigger: 'blur'}],

                },
                isuse:true,
            }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            data:{
                handler() {
                    if (this.data) {
                        //console.log(this.data,'this.data');
                        if (this.data.type=='edit') {
                            this.formData = JSON.parse(JSON.stringify(this.data))
                            console.log(this.formData.i_syncyy_type,'i_syncyy_type')
                            this.isuse=JSON.parse(JSON.stringify(this.data)).isuse
                            this.getSpecificationDistributeList()
                        }else{
                            let now=this.$DateTime.now();
                            this.formData={
                                i_id: 0,
                                    vc_pzname: "",
                                    vc_name: "",
                                    vc_name_nick: "",
                                    vc_ename: "",
                                    vc_cd: "",
                                    vc_gykh: "",
                                    vc_bzstyle: "",
                                    vc_bzunit: "",
                                    f_bl: 1.00,
                                    vc_unit: this.$t('yewuPM_ton'),
                                    f_weight: 0,
                                    i_isbulk:0,
                                    vc_type:this.$t('yewuPM_general_cargo'),
                                    vc_djunit:"KG",
                                    isec: 0,
                                    isjian: 0,
                                    i_flag: "",
                                    i_type_sel:0,
                                    isusepack:0,
                                    i_ispno:2,
                                    i_pzid_kcjs_sel:1,vc_exname:'',
                                    isuse:1,i_ismustcheck:0,i_assayres:0,
                                    i_isprocess:0,i_syncyy_type:'',
                                    vc_priceunit: this.$t('yewuPM_ton'),i_isexport:0,i_sector_id:'',
                                   dt_createtime:now.toFormat('yyyy-MM-dd'),
                                   vc_lruname:sessionStorage.getItem("lruname"),
                                  i_lruid:sessionStorage.getItem("userid"),vc_relate_pz:'',i_relate_pzid:0,
                            }
                        }
                        // console.log('------------',this.data)
                    }
                },
                deep:true,
                immediate:true
            }
        },
        activated(){
            this.onResize();
        },
        mounted(){
            this.getSectorList();
            this.findClassificationAttributes();
            this. getDictList('unit');
            this. getDictList('jzdw');
            this. getDictList('bzdw');
            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            chooseName(){
                this.mcData={
                    flagList:this.flagList
                }
                this.mcOpen()
            },
            chooseNameglcp(){
                this.glcpData={
                    i_leixing:this.formData.i_isprocess
                }
                this.glpzOpen()
            },
            glpzOpen(){
                this.glcpVisible=true
            },
            glcpClose(val){
                //console.log(val,'val--')
                if(val){
                    this.formData.vc_relate_pz=val.vc_name+' '+val.vc_cd+' '+val.vc_gykh+' '+val.vc_bzstyle;
                    this.formData.i_relate_pzid=val.i_id;
                }
                this.glcpVisible=false
            },
            mcOpen(){
                this.mcVisible=true
            },
            mcClose(val){
                //console.log(val,'val--')
                if(val){
                    this.formData.vc_pzname=val.vc_pzname;
                    // this.formData.i_flag=0;
                    this.formData.i_flag=val.i_flag;
                    this.formData.i_pzid_kcjs_sel=val.i_pzid_kcjs_sel;
                    this.formData.i_type_sel=val.i_type_sel;
                    this.formData.i_ispno=val.i_ispno;
                    this.formData.vc_unit=val.vc_unit;
                    this.formData.i_mdid=val.i_mdid;
                    this.formData.i_pid=val.i_pzid;
                    this.formData.i_isprocess=val.i_isprocess;
                    this.formData.vc_priceunit=val.vc_priceunit;
                    this.formData.i_typeid=0;
                    this.formData.i_syncyy_type=val.i_syncyy_type;
                    this.formData.vc_priceunit=val.vc_priceunit;
                    this.formData.i_flag=val.i_flag;
                    this.formData.i_sector_id=val.i_sector_id;
                    this.formData.isjian=Number(val.isjian);
                    this.formData.i_unitgroup_id=val.i_unitgroup_id;
                    this.$forceUpdate()
                }
                this.mcVisible=false
            },

            vc_nameChange(){
                this.$set(this.formData,'vc_name_nick',this.formData.vc_name);
                // console.log(this.formData.vc_name_nick,'this.formData.vc_name_nick')
                // this.formData.vc_name_nick=this.formData.vc_name
                // this.$forceUpdate()
            },
            //单位接口(计量单位)
            async getDictList(type){
                let param={
                    vc_type:'unit',
                    i_isweightunit:type=='jzdw'?1:-1,
                    vc_unit_parent:type=='jzdw'||type=='bzdw'?'':this.data.vc_unit,
                };
                let res=await API.getDictList(param);
                if (res.code==1){
                    //console.log(res,"getDict");
                    if(type=='unit'){
                        this.dictList=res.data;

                    }else if(type=='jzdw'){
                        this.jzdwList=res.data;

                    }else if(type=='bzdw'){
                        this.bzdwList=res.data;

                    }
                    // this.jzdwList=res.data;
                    //console.log(this.dictList,"this.dictList")
                }
            },
            resetFormson(){
                // this.formData={};
                this.$emit('close')
                //console.log(this.formData,"this.formData")
            },

            //新增里保存按钮
            saveadd(formName) {
                // if (this.data.title!="新增产品大类"&&this.data.title!="编辑产品大类"){
                console.log(this.formData)
                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        this.addOrupdateProductSpecification();
                        this.disabled=true;
                    }else{
                        return false
                    }
                })
            },
            saveaddNew() {
                this.$emit('getMDSysMessage');
                //this.$emit('getMDSysMessage');
                this.resetFormson();
            },
            ///新增接口
            async addOrupdateProductSpecification() {
                this.formData.operate=this.formData.i_id?1:0
                this.formData.isyw=1
                this.formData.vc_app=this.baseerp;
                let now=this.$DateTime.now();
                this.formData.dt_createtime=now.toFormat('yyyy-MM-dd');
                this.formData.vc_lruname=sessionStorage.getItem("lruname");
                this.formData.i_lruid=sessionStorage.getItem("userid");
                let param=this.formData;
                let res = await API.addOrupdateProductSpecification(param);
                if (res.code == 1) {
                    this.$emit('close','save');
                    this.$message.success(res.message);
                    this.disabled=false

                    //console.log(res, "addOrupdateProductSpecification");
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                    this.disabled=false
                }else{
                    this.disabled=false;
                    this.$message.error(res.message);
                };
            },
            async findClassificationAttributes(){
                let param={
                };
                let res=await API.findClassificationAttributes(param);
                if ( res.code == 1 ){
                    this.flagList=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            bksearch(e){
                this.bk_seaech=e
                this.getSectorList()
            },
            changeSector(){
                if(this.formData.i_sector_id){
                    this.formData.vc_sector_name=this.bkList.find(g=>g.i_id==this.formData.i_sector_id).vc_name
                }else{
                    this.formData.vc_sector_name=''
                }
            },
            async getSectorList(){
                let param={
                    "vc_search":this.bk_seaech,
                    "i_isuse":1,
                    "pageSize":50,
                    "currentPage":1
                };
                let res=await API.getSectorList(param);
                if ( res.code == 1 ){
                    this.bkList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getSpecificationDistributeList(){
                let param={
                    i_id:this.formData.i_id
                };
                let res=await API.getSpecificationDistributeList(param);
                if ( res.code == 1 ){
                    this.distributedList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        }
    }

</script>

<style lang="scss" scoped>
    .flex{
        display: flex;

    }
    .inputW{
        width: calc(100% - 100px);
    }
    .mrl20{
        margin-left: 20px;
    }

    .mrr50{
        margin-right:100px;
    }

    .cl{
        clear: both;
    }

    .fl{
        float: left;
    }

    .fr{
        float: right;
    }
    .w50{
        width: 50%;
    }
    .w100{
        width: 100%;
    }
    .upload-input {
        position: absolute;
        opacity: 0;
        width: 80px;
        height: 100px;
    }

    /deep/{
        .el-form-item__content{
            width: 230px;
        }
        /*.upload-input[data-v-a4d5ba82]{*/
        /*    right:160px;*/
        /*    bottom: 10px;*/
        /*}*/
    }
    .el-radio{
        margin-right: 12px;
    }
    .el-radio:last-child{
        margin-right: 0;
    }
    div .el-form-item{
        width: 350px;

    }
</style>